import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import resourcesToBackend from 'i18next-resources-to-backend';
import { DEFAULT_LANGUAGE_LOCALE } from '../../services/Constants';

const locales = {
	'en-GB': 'en',
	nl: 'nl',
	'es-ES': 'es',
	'de-DE': 'de',
	'fr-FR': 'fr',
	'pl-PL': 'pl',
	'pt-BR': 'pt-br',
};

i18n.use(initReactI18next)
	.use(resourcesToBackend((language, namespace) => import(`./${locales[language]}Locale.json`)))
	.init({
		lng: localStorage.getItem('selectedLocale') || DEFAULT_LANGUAGE_LOCALE,
		fallbackLng: 'en-GB',
		supportedLngs: ['en-GB', 'nl', 'es-ES', 'de-DE', 'fr-FR', 'pl-PL', 'pt-BR'],
		interpolation: {
			escapeValue: false,
		},
		ns: ['translation'],
		defaultNS: 'translation',
	});

export default i18n;
